import { autoUpdate, computePosition, flip, shift } from '@floating-ui/dom';

const DropdownHook = {
  mounted() {
    this.cleanup;

    this.toggleEl = this.el.querySelector('[data-dropdown=toggle]');
    this.contentEl = this.el.querySelector('[data-dropdown=content]');

    this.el.addEventListener('shown', () => {
      requestAnimationFrame(() => {
        this.cleanup = autoUpdate(this.toggleEl, this.contentEl, this.updatePosition.bind(this));
      });
    });

    this.el.addEventListener('hidden', () => {
      this.cleanup && this.cleanup();
    });

    this.el.addEventListener('hide', () => {
      liveSocket.execJS(this.el, this.el.dataset.hide);
      this.cleanup && this.cleanup();
    });

    this.updatePosition();
  },

  updated() {
    this.updatePosition();
  },

  updatePosition() {
    computePosition(this.el, this.contentEl, {
      placement: this.getPlacement(),
      middleware: [flip({ padding: 10 }), shift({ padding: 10 })],
      strategy: 'fixed',
    }).then(({ x, y }) => {
      Object.assign(this.contentEl.style, {
        left: `${x}px`,
        top: `${y}px`,
      });
    });
  },

  getPlacement() {
    const anchor = this.el.dataset.anchor;
    const translateMap = {
      start: 'bottom-start',
      end: 'bottom-end',
    };

    return translateMap[anchor];
  },
};

export default DropdownHook;
